// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"713d8b05","667":"fef8aef9","977":"3e3a625b"}[chunkId] + ".chunk.js";
};